import Header from './template_01';

const DefaultHeader=(props) =>{
    return (
        <Header {...props}/>
    );
  }
  
  export default DefaultHeader;